import {
    ua,
    qs,
    getDeepVal
} from '@kkmh/utils'
import {
    getH5Membergoods,
    getH5MembergoodsBrowser,
    freeCalculate,
    freeAssignH5,
    getUserMe,
    delayAddH5, 
    getHeladike,
    getTopic,
    orderMarketing,
} from "../../../assets/api";
import {
    getPayParam,
    getNativeInfo,
    jumpToLogin,
    setTrack,
} from "../../../assets/utils";
import {get_entrance_param, get_storage, set_storage} from '@kk/h5-sdk'
import {setSelectCouponId} from './comp'

window.selectcoupon_is_passed_by_here = false;
export const getBaseParam = (opt = {}) => {
    return new Promise(resolve => {
        getNativeInfo().then((nativeinfo) => {
            let param               = {
                good_id             : parseInt(qs['good_id']) || 0, //端外优惠券列表里选中后回到当前页面时需要指定选中的档位
                // 6.2需求定向限免的挽留发券弹窗、使用优惠券弹窗 1.若券已指定档位直接拉起半屏选中该档位
                select_goodid       : opt.select_goodid || (parseInt(qs['select_goodid']) || 0),    //服务端拼接（选中档位-ui表现）
                select_couponid     : opt.select_couponid || (parseInt(qs['select_couponid']) || 0),//服务端拼接（选中档位下优惠券-ui表现）
                //6.5需求-定向限免H5支持长周期
                topic_id            : opt.topic_id || (parseInt(qs['topic_id']) || 0),              //服务端拼接（传递给接口&客户端)
                comic_id            : opt.comic_id || (parseInt(qs['comic_id']) || 0),              //服务端拼接（传递给接口&客户端)
                third_activity      : opt.third_activity || (qs['third_activity'] || ''),           //产品/测试拼接（传递给接口-活动名称
                get_right_now       : opt.get_right_now || (qs['get_right_now'] || ''),             //产品/测试拼接（传递给接口-是否立即领取）
                source_type         : opt.source_type || (qs['source_type'] || ''),                 //产品/测试拼接（传递给接口-调用来源类型）
                notice_type         : opt.notice_type || (qs['notice_type'] || '') || (window.nat_notice_type || ''), //产品/测试拼接 or 客户端给予：（传递给埋点-入口名称）
                vip_source          : opt.vip_source || (window.nat_vip_source || ''),              //产品/测试拼接 or 客户端给予：（传递给埋点-入口名称）
                non_iap_supported   : opt.non_iap_supported || (qs['non_iap_supported'] || 0),      //产品/测试拼接（传递给接口）运营位是否支持越狱，1表示支;
                origin              : opt.trigger_page || '',       //父组件传递的活动名称
                trigger_page        : '会员半屏弹窗页',
                good_type           : 2,                            //必须-int 1.kkb 2.vip
                platform            : !ua['kkmh'] ? 3 : ua['android'] ? 1 : 2, //1：安卓，2：ios，3：H5，优先取platform，如果platform没传，就按userAgent取
                activity_type       : opt.activity_type || 0,       //活动类型:1.普通活动 2.天降礼包活动
                activity_info       : opt.activity_info || {        //不必须-object【vip半屏】会员日活动时需要按模块显示此字断
                    main_text   : '',
                    sub_text    : '',
                },
                bg_color            : opt.bg_color || {             //不必须-object【vip半屏】透明色设置
                    color   : '000000', //6位背景色，默认黑色透明50%
                    opacity : 0.5,      //透明
                },
                compel_iap      : opt.compel_iap || false,          //不必须-boolean【vip半屏】什么场景传递?勾选越狱商品选择用iap支付时传递true下发iap商品
                coupon_type     : opt.coupon_type || 0,             //不必须-int【vip半屏】0:使用第一个, 1:使用最大的优惠券 2:待扩充  
            }
            //初始化埋点信息
            let track_id = nativeinfo.uid || nativeinfo.device_id;
            setTrack(track_id)

            resolve({
                ...getPayParam(opt),
                ...nativeinfo,
                ...param
            })
        });
    })
}
export const checkParamPassed = (opt = {}) => {
    return new Promise(resolve => {
        (async () => {
            if ((ua['iphone'] && ua['kkmh']) || !ua['kkmh']) {
                // 不做验证登录，游客模式可支付 or 浏览器下不验证登录
                resolve({code:200,data:{},message:'ok'});
                return null;
            } else {
                let res = await getUserMe();
                let nickname = getDeepVal(res,'data.user.nickname','');
                if (!nickname) {
                    let islogin = await jumpToLogin();
                    if (islogin) {
                        res = await getUserMe();
                        resolve({code:200,data:res.data,message:'ok'});
                        return null;
                    } else {
                        resolve({code:401,message:'未登录'});
                        return null;
                    }
                }
                resolve({code:200,data:res.data,message:'ok'});
                return null;
            }
        })()
    })
}
export const getVipViewData = (opt) => {
    return new Promise(resolve => {
        (async () => {
            let vipdata = {};
            let res = {};
            // if (ua['kkmh']) {
                res = await getH5Membergoods(opt);
                if (res.code !== 200) {
                    resolve({code:-31011, message:res.message});
                    return null;
                }
                vipdata = getViewData(res.data);
            // } else {
            //     res = await getH5MembergoodsBrowser(opt);
            //     if (res.code !== 200) {
            //         resolve({code:-31012, message:res.message});
            //         return null;
            //     }
            //     vipdata = getViewDataBrowser(res.data);
            // }

            // 追加combo
            let combo_list = getAryComb(vipdata.goods);
            let combodata  = [];
            if (opt.third_activity && combo_list.length > 0) {
                opt.combo_list = combo_list.join(',');
                let {code, data=[], message} = await getComboList(opt);
                if (code !== 200 && code !== 401) {
                    resolve({code:-31013, message});
                    return null;
                }
                combodata = (typeof data === 'object' && !isNaN(data.length)) ? data : [];
            }

            // 设置全局charge_activity
            if (getDeepVal(opt,'activity_info.main_text','')) {
                vipdata.charge_activity.words_info.main_text    = getDeepVal(opt,'activity_info.main_text','');
                vipdata.charge_activity.words_info.sub_text     = getDeepVal(opt,'activity_info.sub_text','');
                vipdata.charge_activity.show_main_icon_type     = opt.activity_type;
            }
            // 设置combo相关的charge_activity
            vipdata.goods = setComboInfo(vipdata, combodata);

            // 判断所有商品里是否有优惠券
            vipdata.hascoupon = getHasCoupon(vipdata);

            // 获取选中的档位
            vipdata.choise = getChoiseInfo(opt, vipdata);

            // 设置trackinfo
            if (!ua['kkmh']) {
                setTrack(getDeepVal(vipdata,'user.id',''));    
            }
            
            resolve({code:res.code, data:vipdata, message:res.message});
        })();
    })
}
export const getVipList = (opt) => {
    return new Promise(resolve => {
        // if (ua.kkmh) {
            getH5Membergoods(opt).then((res) => {
                resolve(res);
            }).catch(error => {
                resolve(error);
            });
        // } else {
        //     getH5MembergoodsBrowser(opt).then((res) => {
        //         resolve(res);
        //     }).catch(error => {
        //         resolve(error);
        //     })
        // }
    })
}
// 定向combo信息
export const getComboList = (opt) => {
    return new Promise(resolve => {
        freeCalculate(opt).then((res) => {
            resolve(res);
        }).catch(error => {
            resolve(error);
        });
    })
}
// 定向combo注册
export const setComboAssign = (opt, free_encrypt_str) => {
    return new Promise(resolve => {
        freeAssignH5(opt, free_encrypt_str).then((res) => {
            let {code, data={}, message=''} = res;
            if (code !== 200) {
                resolve('领取异常-'+'['+code+']'+message);
                return null;
            }
            let {assign_status=0} = data;
            if (assign_status !== 1) {
                // switch (assign_status){
                //     case 0: // 失败
                //     case 2: // 已领取(检查record_id是否重复)
                //     case 18000: // 重复提交记录
                //     case 2005: // 领取异常
                //     break;
                // }
                resolve('领取异常-请退出后重试！');
                return null;   
            }
            resolve();
        }).catch(error => {
            resolve(error);
        });
    })
}
// 支付成功后的订单相关福利信息
export const getOrderInfo = (opt) => {
    return new Promise(resolve => {
        orderMarketing(opt).then((res) => {
            let {code, data={}, message=''} = res;
            if (code !== 200) {
                resolve({message:'['+code+']'+message});
                return null;
            }
            resolve(data);
        }).catch(error => {
            resolve(error);
        });
    })
}

export const payAfterMustDelCoupon = (goods, goodinfo) => {
    let cur_num = getDeepVal(goods,'choise.num',0);
    let cur_couponid = goodinfo.couponid || '';
    if (!cur_couponid) {
        return goods;
    }
    goods.forEach((item, index) => {
        let ary = getDeepVal(item,'coupon.usable_list',[]);
        ary.forEach((sitem, sindex) => {
            if (sitem.id == cur_couponid) {
                item.coupon.usable_list.splice(sindex, 1) //删除
            }
        })
    })
    return goods;
}

// 获取选中的档位
const getChoiseInfo = ({good_id, select_goodid, select_couponid} = {}, {goods} = {}) => {
    let choise_good_id = 0;
    let choise_good_num = 0;
    /*  目标：定向限免-服务端会拼接进来select_goodid && select_couponid
        ** 问题：第一次设置完选中优惠券后，用户再一次通过优惠券列表页面选另一张优惠券时
        ** 1.端外会刷新回来，需要通过good_id参数来判断涞源页面是优惠券列表页，且不再设置setSelectCouponId
        ** 2.防止getBaseParam方法多次调用导致执行多次setSelectCouponId，用is_passed_by_here来标记
    */
    // 需判断是否是从优惠券页过来的？不是则设置选中档位和优惠券
    if(!good_id && !window.selectcoupon_is_passed_by_here) {
        window.is_passed_by_here = true;
        // 定向限免-服务端会拼接进来 
        if (/select_goodid/.test(location.href) && /select_couponid/.test(location.href)) {
            // 1.select_couponid 有值
            if (select_goodid && select_couponid) {
                choise_good_id = select_goodid;
                setSelectCouponId(select_goodid, select_couponid);    
            } 
            // 2.select_couponid 没有值
            if (select_goodid && !select_couponid) {
                //获取用券后实际金额最小的档位
                let cheap = getCheapGood(goods);
                choise_good_id = cheap.goodid;
                setSelectCouponId(cheap.goodid, cheap.couponid);
            }
        }
    }

    // 从优惠券页来的 或者也可以是业务方想指定的也好
    if (good_id) {
        choise_good_id = good_id;
    }

    // 查看是否存在与商品列表里
    let flag = false;
    goods.forEach((item, index) => {
        if (item.id == choise_good_id) {
            choise_good_num = index;
            flag = true;
        }
    })

    // 没找到就取第一个商品
    if (!flag) {
        choise_good_id = getDeepVal(goods,'0.id','');
        choise_good_num = 0;
    }

    return {
        id  : choise_good_id,
        num : choise_good_num
    };
}

//获取用券后实际金额最小的档位
const getCheapGood = (goods) => {
    let cheaplist = [];
    goods.forEach((item,index) => {
        let usable_list = getDeepVal(item,'coupon.usable_list',[]);
        usable_list.forEach((sitem,index) => {
            sitem.goodid = item.id;
            cheaplist.push({
                goodid : item.id, 
                couponid : sitem.id,
                final_price : sitem.final_price,
            });
        })
    })
    cheaplist.sort(function(a, b){return a.final_price - b.final_price});
    let cheap = cheaplist[0] || {};

    return {
        goodid   : cheap.goodid,
        couponid : cheap.couponid
    };
}
//判断所有商品里是否有优惠券-
const getHasCoupon = ({ recharge_type, goods } = {}) => {
    let hascoupon = false;
    if (ua['appversion'] >= 531000 || !ua['kkmh']) {
       if (recharge_type==4) {//4 => 苹果支付则不显示优惠券
            return hascoupon;
        }
        goods.forEach((item,index) => {
            if (getDeepVal(item,'coupon.usable_list',[]).length > 0) {
                hascoupon = true;
            }
        }) 
    }
    return hascoupon
}
const setComboInfo = ({goods=[], charge_activity={}} = {}, combodata) => {
    goods.forEach((item,index) => {
        item.charge_activity = JSON.parse(JSON.stringify(charge_activity));
        combodata.forEach((sitem,sindex) => {
            if (item.combo == sitem.combo) {
                item.comboinfo = sitem;
                if (sitem.combo_head_text) {
                    item.charge_activity.words_info.main_text = sitem.combo_head_text;
                    
                }
            }
        })
    })
    return goods;
}
const getAryComb = (goods) => {
    let ary = [];
    goods.forEach((item,index) => {
        if (item.combo) {
            ary.push(item.combo)    
        }
    })
    return ary;
}
const getViewData = (data) => {
    let member          = getDeepVal(data,'members.0',[]);
    let user            = getDeepVal(data,'user',{});
    let vip_user        = getDeepVal(data,'vip_user',{});
    let charge_activity = getDeepVal(data,'charge_activity',{words_info:{}});
    let recharge_type   = member.recharge_type || 0;
    let goods           = member.member_goods || [];
    
    let obj = {
        user,
        vip_user,
        charge_activity,
        recharge_type,
        goods,
    };
    return obj;
}
const getViewDataBrowser = (data) => {
    let member          = getDeepVal(data,'members.0',[]);
    let user            = getDeepVal(data,'user',{});
    let vip_user        = getDeepVal(data,'vip',{});
    let charge_activity = getDeepVal(data,'charge_activity',{words_info:{}});
    let recharge_type   = member.recharge_type || 0;
    let rechargegood    = member.recharge_goods || [];
    let renewgood       = member.renew_goods || [];
    let renew_status    = data.user_member_renew_status || 0;// 用户自动续费状态 0：否 1：是
    let goods           = renew_status ? rechargegood : rechargegood.concat(renewgood);
    
    //正常排序
    goods.sort(function(a,b){
        return a.sequence - b.sequence;
    })
    //后台优惠配置选择商品ID，该商品需显示在第一位
    goods.sort(function(a,b){
        return b.selected - a.selected;
    })
    //与native的格式保持一致
    goods.forEach((item,index) => {
        item.price = {
            real_price : item.real_price,
            mark_price : item.mark_price,
        }
    })

    let obj = {
        user,
        vip_user,
        charge_activity,
        recharge_type,
        goods,
    };
    return obj;
}

export const openMission = (opt) => {
    return new Promise(resolve => {
        Promise.all([delayAddH5(opt), getHeladike(opt), getTopic(opt)]).then(res => {
            let res1 = res[1] || {};
            let res2 = res[2] || {};
            window.heladikedata = res1.data || {}
            window.topicdata = res2.data || {}
            resolve(res)
        })    
    })
}

// 设置客户端入口数据
(function() {
    if(ua['appversion'] >= 567000) {
        get_entrance_param({
            callback : (res) => {
                let { code=200, data={}, message='ok' } = res || {};
                window.nat_notice_type  = data.notice_type || '';
                window.nat_vip_source   = data.vip_source || '';
            }
        })
        return null;
    }
    if(ua['appversion'] >= 559000) {
        get_storage({
            param : {
                key : 'pay_data',
            },
            callback : (res) => {
                let { code=200, data={}, message='ok' } = res || {};
                window.nat_notice_type  = data.notice_type || '';
                window.nat_vip_source   = data.vip_source || '';

                //删除value
                data.notice_type = '';
                data.vip_source = '';
                set_storage({
                    param : {
                        key : 'pay_data',
                        data : JSON.stringify(data)
                    },
                    callback : (res) => {
                        
                    }
                })
            }
        })
    } 
})()







// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/viphalfscreen/js/common.js